import {
    WALLET_BTC_BTCOUT_ERROR,
    WALLET_BTC_BTCOUT_SUBMIT,
    WALLET_BTC_BTCOUT_SUCCESS, 
    WALLET_BTC_BALANCE_ERROR,
    WALLET_BTC_BALANCE_LOAD,
    WALLET_BTC_BALANCE_SUCCESS,
    WALLET_BTC_FEE_ERROR,
    WALLET_BTC_FEE_LOAD,
    WALLET_BTC_FEE_SUCCESS,
} from '../actionTypes'
import { loadFavorites } from './wallet_transactions'
import { request } from '../../utils/api'

export const getBtcOut = (form, value, tabAtiva, priority, userid) => async dispatch => {
    form.validateFieldsAndScroll(async (err, values) => {
        if(!err){
            try{
                dispatch(btcOutSubmit())
                // const { code, message, id } = await request('wallet/btc-out', "POST", {
                const { code, message, id } = await request('wallet/transaction', "POST", {
                    address: values.address,
                    name: values.name,
                    value: value,
                    favorite: tabAtiva,
                    priority,
                    userid
                })
        
                // await dispatch(loadBalance(userid))
                
                // TODO : descobrir o que essa funcionalidade faz =>
                if(code === 61) {
                        await dispatch(loadBalance(userid))
                        dispatch(btcOutSuccess(message))
                        // dispatch(loadBalance(userid)).then(() => window.location.replace(`/wallet/transacao?id=${id}&type=1&status=0`))
                        setTimeout(() => {
                    }, 8000)
                } else {
                    dispatch(btcOutError(message))
                }
            }
            catch(e) {
                console.log(e)
                dispatch(btcOutError())
            }
        }
    })
}

export const btcOutSubmit = () => ({
    type: WALLET_BTC_BTCOUT_SUBMIT
})

export const btcOutError = (message = 'Houve um erro ao realizar a transação') => ({
    type: WALLET_BTC_BTCOUT_ERROR,
    payload: {
        message
    }
})

export const btcOutSuccess = (message) => ({
    type: WALLET_BTC_BTCOUT_SUCCESS,
    payload: {
        message
    }
})

export const loadBalance = (id) => async dispatch => {
    try {
        dispatch(balanceLoad())
        const { code, balance } = await request(`wallet/balance/${id}`)
        console.log("wallet_btc",balance)
        dispatch(balanceSuccess(balance))
        if(code === 51) {
            console.log(code)
        } else {
            dispatch(balanceError())
        }
    } catch (e) {
        dispatch(balanceError(e))
    }
}

export const balanceSuccess = (balance) => ({
    type: WALLET_BTC_BALANCE_SUCCESS,
    payload: {
        balance
    }
})

export const balanceError = (message = 'Houve um erro ao carregar seu saldo.') => ({
    type: WALLET_BTC_BALANCE_ERROR,
    payload: {
        message
    }
})

export const balanceLoad = () => ({
    type: WALLET_BTC_BALANCE_LOAD
})

export const loadFees = () => async dispatch => {
    try {
        dispatch(feeLoad())
        const { code, fees } = await request('wallet/fee')
        if(code === 51) {
            dispatch(feeSuccess(fees))
        } else {
            dispatch(feeError())
        }
    } catch(e) {
        dispatch(feeError(e))
    }
}

export const feeSuccess = (fees) => ({
    type: WALLET_BTC_FEE_SUCCESS,
    payload: {
        fees
    }
})

export const feeLoad = () => ({
    type: WALLET_BTC_FEE_LOAD
})

export const feeError = (message = 'Houve um erro ao reenviar o código. Tente novamente.') => ({
    type: WALLET_BTC_FEE_ERROR,
    payload: {
        message
    }
})
